/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiAvAsset } from './AvAsset';

export interface ArticleBlockRequest {

    id?: string;

    /**
     * Lead image
     */
    image?: string;

    /**
     * Lead image credit
     */
    image_credit?: string;

    /**
     * Image caption
     */
    image_caption?: string;

    audio?: ApiAvAsset;

    video?: ApiAvAsset;

    html_embed?: string;

    body?: string;

}

@Model('ArticleBlock')
export class ApiArticleBlock extends BaseModel implements ArticleBlockRequest {

    
    
    id: string;

    /**
     * Lead image
     */
    
    
    image: string;

    /**
     * Lead image credit
     */
    
    
    image_credit: string;

    /**
     * Image caption
     */
    
    
    image_caption: string;

    @Type('ApiAvAsset')
    @Expand()
    audio: ApiAvAsset;

    @Type('ApiAvAsset')
    @Expand()
    video: ApiAvAsset;

    
    
    html_embed: string;

    
    
    body: string;

}
